
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obituaries/[slug]/memories",
      function () {
        return require("private-next-pages/obituaries/[slug]/memories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obituaries/[slug]/memories"])
      });
    }
  